export default "/assets/weekly-measurements-chart-placeholder.png";